import React, { FC, memo, useMemo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { replaceAttributes } from "@super-ui/components/m2c-swiggy-one-halfcard/helpers";
import { REMOVE_BLCK_PLAN_COLOR_TAGS, REMOVE_PLAN_COLOR_TAGS, REMOVE_PLAN_STRIKED_TAGS } from "../../constants";
import { PLACEHOLDERS } from "@super-ui/constants";
import { Content } from "@swiggy-private/cart-types";

const RemoveHalfcardTitle: FC<{ content: Content; isSwiggyBlackType?: boolean }> = ({ content, isSwiggyBlackType }) => {
    const newTitle = content.title || "";

    const contentTitle = useMemo(() => {
        let tagsToReplace = isSwiggyBlackType ? REMOVE_BLCK_PLAN_COLOR_TAGS : REMOVE_PLAN_COLOR_TAGS;

        // To handle auto add, In case of base price, replace the attributes and strike the tags
        if (newTitle.includes(PLACEHOLDERS.BASE_PRICE)) {
            tagsToReplace = REMOVE_PLAN_STRIKED_TAGS;
        }

        return replaceAttributes(newTitle, content.attribute_values, tagsToReplace);
    }, [content.attribute_values, isSwiggyBlackType, newTitle]);

    return (
        <Text
            as="span"
            variant={isSwiggyBlackType ? "V2.heading2.neutral.black" : "V2.heading1.neutral.black"}
            color="text_Highest_Emphasis"
            dangerouslySetInnerHTML={{ __html: contentTitle }}
        />
    );
};

export default memo(RemoveHalfcardTitle);
